import React from "react";
import CreditCard from "./CreditCard";
import RecentTransactions from "./RecentTransactions";
import FavBenficiaries from "./FavBenficiaries";

const MainbarCards1 = () => {
  return (
    <div className="ml-5 flex flex-row mb-5">
      <CreditCard />
      <RecentTransactions />
      <FavBenficiaries />
    </div>
  );
};

export default MainbarCards1;
